export const theme = {
  colors: {
    primary: '#4A6FA5', // Dermapuris Blue
    secondary: '#E8B4B8', // Dermapuris Pink/Rose
    background: '#f8f2ed', // Soft cream background for the whole app
    backgroundAlt: '#F9F7F5', // Light cream/beige
    textPrimary: '#2C3E50', // Deep navy
    textSecondary: '#6C757D', // Medium grey
    success: '#28A745', // Soft green
    border: '#E9ECEF', // Light grey
  },
  typography: {
    fontFamily: {
      primary: '"Playfair Display", serif', // Clean, professional serif font
      secondary: '"Inter", sans-serif', // Modern sans-serif for supporting text
    },
    fontSize: {
      base: '16px',
      h1: '2.5rem',
      h2: '2rem',
      h3: '1.75rem',
      h4: '1.5rem',
      body: '1rem',
      small: '0.875rem',
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  breakpoints: {
    mobile: '375px',
    tablet: '768px',
    desktop: '1024px',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 6px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.1)',
  },
  transitions: {
    default: '0.3s ease',
    fast: '0.15s ease',
    slow: '0.5s ease',
  },
}; 